import React from 'react';
import { View, StyleSheet } from 'react-native';

interface PaymentSectionDividerProps {
  style?: any;
}

export const PaymentSectionDivider: React.FC<PaymentSectionDividerProps> = ({ style }) => {
  return <View style={[styles.sectionDivider, style]} />;
};

const styles = StyleSheet.create({
  sectionDivider: {
    height: 1,
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
});
